import React, { useMemo } from 'react'
import * as THREE from 'three'
import {useRigidBody, BodyType, ShapeType, ShapeFit} from 'use-ammojs'
import usePlayerControls from '../custom hooks/usePlayerControls'
import { useFrame, useThree } from '@react-three/fiber'
import useStore from '../StateStore/store'


const SPEED = 60;

const direction = new THREE.Vector3()
const frontVector = new THREE.Vector3()
const sideVector = new THREE.Vector3()
const euler = new THREE.Euler(0, 0, 0, "YXZ")


const Box = ({position}) => {

    const {camera} = useThree()

    const [ref, api] = useRigidBody(() => ({
        mass : 1,
        bodyType: BodyType.DYNAMIC,
        shapeType: ShapeType.SPHERE,
        position : [0, 1, 0]
      }))

      const teleportation = useStore(state => state.playerTeleport)
      const setTeleport = useStore(state => state.playerTeleport.setTeleport)

      const vectors = useMemo(() => {
          return{
              x : new THREE.Vector3(),
              y : new THREE.Vector3()
          }
      }, [])

      const teleport = () => {
        if(teleportation.position){
            // vectors.x.set(teleportation.position.x, 0, teleportation.position.z)
            // vectors.y.lerp(vectors.x, 0.03)
    
            // api.setPosition(vectors.y)
    
            // if(camera.position.distanceTo(teleportation.position) <= 6){
            //   setTeleport(false)
            // }
          }
      }
    
    let {forward, backward, left, right, up, down} = usePlayerControls()

    useFrame(() => {
        // blind.current.position.set(ref.current.position.x, 5, ref.current.position.z )
       
        // if(teleportation.teleportState === true){
        //     teleport()
        // }else{
        //     vectors.y.set(camera.position.x, 0, camera.position.z )
        // }

        

        // if(controllerState.buttonsActive === true){
        //   forward = controllerState.movementState.forward
        //   backward = controllerState.movementState.backward
        //   left = controllerState.movementState.left
        //   right = controllerState.movementState.right
        // }
        
        // camera.position.set(ref.current.position.x, 5, ref.current.position.z)
        // ref.current.position.copy(camera.posit)
        frontVector.set(0, 0, Number(backward) - Number(forward))
        euler.setFromQuaternion( camera.quaternion );
        euler.y += (Number(left)-Number(right)) * 0.015
        euler.x += (Number(up)-Number(down)) *0.015
        if(Number(forward) > 0 || Number(backward) > 0 ){
          euler.x = THREE.MathUtils.lerp(euler.x, 0, 0.03)
          euler.z = THREE.MathUtils.lerp(euler.z, 0, 0.03)
          
        }
        camera.quaternion.setFromEuler( euler );
        sideVector.set(0, 0, 0)
        direction.subVectors(frontVector, sideVector).normalize().multiplyScalar(SPEED).applyEuler(camera.rotation)
        api.setLinearVelocity(direction)
    })

    return (
        <mesh
            ref={ref}
        >
            <sphereBufferGeometry args={[1,60,60]} />
            <meshBasicMaterial visible={true} />
        </mesh>
    )
}

export default Box
